import { Directive, EventEmitter, inject, Output } from "@angular/core";
import { BehaviorSubject, lastValueFrom, ReplaySubject, take, tap } from "rxjs";

import { IIPEmail } from "../body/body";
import { AIPEmailBuilderRestService } from "../services";
import { IUserTemplateCategory } from "../interfaces";
import { TemplateService } from "../services/template.service";
import { StorageService } from "src/app/shared/services/storage.service";
import { ToastrService } from "ngx-toastr";
import { HttpClient } from "@angular/common/http";

@Directive()
export abstract class AIPTemplateList {
  readonly http = inject(HttpClient);
  @Output() selected = new EventEmitter<IIPEmail>();
  selectedCategory$ = new ReplaySubject<IUserTemplateCategory>();
  readonly restService = inject(AIPEmailBuilderRestService);
  page: number = 1;
  pageSize: number = 10;
  totalRecords: number = 0;
  categoryList = [
    // {
    //   category: "ecommerce",
    //   templates: ["clothes", "e-shop", "shipping"],
    // },
  ];
  tmplCategories$ = new BehaviorSubject<any[]>([]);
  //  selectedCategory$ = new BehaviorSubject<any>(this.categoryList[0]);

  // tmplCategories$ = this.restService.tmplCategories$().pipe(
  //   tap(([category]) =>
  //     this.selectedCategory$.next(category))
  // );
  constructor(
    private apiService: TemplateService,
    private storageService: StorageService,
    public toaster: ToastrService
  ) {
    this.getAllList();
  }
  getAllList() {
    this.storageService.store("templateId", undefined);
    const data = {
      pageNumber: this.page,
      pageSize: this.pageSize,
    };
    this.apiService.getAllList(data).subscribe((res) => {
      if (res.isSuccess) {
        const dataArray = res.response;
        this.totalRecords = res.totalRecords;
        this.categoryList = dataArray;
        const categoryList = dataArray.map((item: any) => ({
          category: item.templateName,
          templates: [item.templateName],
        }));
        this.tmplCategories$.next(categoryList);
        this.selectedCategory$.next(categoryList[0]);
        this.toaster.success(res?.message);
      } else {
        this.toaster.error(res?.message);
      }
    });
  }
  selectCategory(category: IUserTemplateCategory): void {
    this.selectedCategory$.next(category);
  }

  selectTemplate(category: string, template: string): void {
    this.restService
      .tmplCategories$(category, template)
      .pipe(take(1))
      .subscribe((template) => {
        this.selected.next(template);
      });
  }
  templateId: any;
  selectedTemplate(category: any): void {
    let template: any = this.categoryList[0];
    this.templateId = template.templateId;
    this.apiService.getByTemplateId(this.templateId).subscribe((res) => {
      if (res.isSuccess) {
        this.storageService.store("templateId", this.templateId);
        let template = JSON.parse(res.response.templateData);
        this.selected.next(template);
        this.toaster.success(res?.message);
      } else {
        this.toaster.error(res?.message);
      }
    });
  }
  async onselectedTemplate(category: any, index: number) {
    let template: any = this.categoryList[index];
    this.templateId = template.templateId;
    this.apiService.getByTemplateId(this.templateId).subscribe((res) => {
      if (res.isSuccess) {
        this.storageService.store("templateId", this.templateId);
        let template = JSON.parse(res.response.templateData);
        this.selected.next(template);
        this.toaster.success(res?.message);
      } else {
        this.toaster.error(res?.message);
      }
    });
    // const template = await lastValueFrom(
    //   this.http.get<IIPEmail>(`/templates/${category}/${category.name}/index.json`),
    //   {
    //     defaultValue: null,
    //   }
    // );
    // if (template) {
    //   this.selected.next(template);
    // }
  }

  deleteTemplate(index: number) {
    let template: any = this.categoryList[index];
    this.templateId = template.templateId;
    this.apiService.deleteTemplate(this.templateId).subscribe((res) => {
      if (res.isSuccess) {
        this.toaster.success(res?.message);
        this.getAllList();
      } else {
        this.toaster.error(res?.message);
      }
    });
  }
  onPageChanged(pageNo: number) {
    this.page = pageNo;
    this.getAllList()
  }
}
